import { Database, Inbox, RefreshCw, Search } from 'lucide-react';

const NoDataMessage = ({
  title = 'No data found',
  message = 'There is nothing to display here right now.',
  onAction,
  actionText = 'Try Again',
  icon = 'database',
  imageUrl
}: {
  title?: string;
  message?: string;
  onAction?: () => void;
  actionText?: string;
  icon?: 'database' | 'inbox' | 'search' | 'folder';
  imageUrl?: string;
}) => {
  const getIcon = () => {
    switch (icon) {
      case 'search':
        return <Search className='h-16 w-16 text-gray-400' />;
      case 'inbox':
        return <Inbox className='h-16 w-16 text-gray-400' />;
      case 'folder':
        return <Database className='h-16 w-16 text-gray-400' />;
      default:
        return <Database className='h-16 w-16 text-gray-400' />;
    }
  };

  return (
    <div className='rounded-xl border border-gray-100 bg-white p-12 shadow-sm'>
      <div className='flex flex-col items-center justify-center space-y-6 text-center'>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt='No data illustration'
            className='h-32 w-32 object-contain opacity-60'
          />
        ) : (
          <div className='flex h-24 w-24 items-center justify-center rounded-full bg-gray-50'>
            {getIcon()}
          </div>
        )}
        <div className='space-y-3'>
          <h3 className='text-xl font-semibold text-gray-900'>{title}</h3>
          <p className='max-w-md text-gray-500'>{message}</p>
        </div>
        {onAction && (
          <button
            onClick={onAction}
            className='inline-flex items-center space-x-2 rounded-lg bg-blue-500 px-6 py-3 font-medium text-white transition-colors duration-200 hover:bg-blue-600'
          >
            <RefreshCw className='h-4 w-4' />
            <span>{actionText}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default NoDataMessage;
